<template>
  <DashboardBottomCardContent
    :callToActionButtonText="$t('L_revisit_goals')"
    @callToActionCallback="goToCalculator"
  >
    <template #icon>
      <v-img
        :src="calreturnIcon"
        width="65"
        max-width="65"
        alt="calreturn-icon"
        role="presentation"
        class="ma-0"
      />
    </template>
    <template #content>
      <h4 role="heading" aria-level="3" class="ml-6">
        <span class="text-h4 d-block font-weight-bold">{{ retirementTrackerHeader }}</span>
        <span class="d-block font-weight-regular">{{ retirementTrackerText }}</span>
      </h4>
    </template>
  </DashboardBottomCardContent>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useCustomerStore } from '@/stores/customer/customer.store';
import calreturnIcon from '../assets/calreturn_icon.svg';
import { RouteNames } from '@/router/routeNames';
import DashboardBottomCardContent from '../../DashboardBottomCardContent.vue';
import { mapStores } from 'pinia';
import { $t } from '@/i18n/i18n.ts';
import type { Router } from 'vue-router';

export default defineComponent({
  name: 'RetirementTracker',
  data() {
    return { calreturnIcon };
  },
  components: { DashboardBottomCardContent },
  computed: {
    ...mapStores(useCustomerStore),
    retirementGoalPercentage() {
      return (
        this.customerStore.investments.calculator?.projection?.percentRetirementIncomeGoal ?? 0
      );
    },
    retirementTrackerHeader() {
      return this.retirementGoalPercentage >= 100
        ? this.$t('L_congratulations')
        : this.$t('L_retirement_goal_tracker');
    },
    retirementTrackerText() {
      return this.retirementGoalPercentage >= 100
        ? this.$t('L_appear_to_be_on_track')
        : this.$t('L_are_you_on_track');
    },
  },
  methods: {
    $t,
    async goToCalculator(this: { $router: Router }) {
      await this.$router.push({ name: RouteNames.INVESTMENT_CALCULATOR });
    },
  },
});
</script>

<style lang="scss" scoped>
.icon {
  text-align: center;
  width: 65px;
  height: 65px;
  object-fit: contain;
}
</style>
